import axios from "axios";

const apiUrl = process.env.REACT_APP_API_BASE_URL;
export const client = axios.create({
  baseURL: apiUrl,
});

// REQUEST INTERCEPTOR
client.interceptors.request.use(
  (request) => {
    const authData = localStorage.getItem("auth");
    const parsed = authData ? JSON.parse(authData) : null;
    const accessToken = parsed?.tokens?.accessToken;

    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }

    return request;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
